import React, { useEffect } from "react";
import MainContainer from "../../components/container/MainContainer";
import { useDispatch, useSelector } from "react-redux";
import SecondContainer from "../../components/container/SecondContainer";
import PageTitle from "../../components/titles/PageTitle";
import Loading from "../../components/loading/Loading";
import { Link } from "react-router-dom";
import SelectSearchField from "./../../components/form/SelectSearchField";
import { useForm } from "react-hook-form";
import AsyncSelectInput from "../../components/form/AsyncSelectInput";
import { getProjectsByTerm, unsetProjects } from "../../features/projectsSlice";

const ManageProjects = () => {
  const dispatch = useDispatch();
  const projects = useSelector((state) => state.projects.data);
  const loading = useSelector((state) => state.projects.getProject);

  const {
    register,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    return () => {
      dispatch(unsetProjects());
    };
  }, []);

  useEffect(() => {}, [projects]);

  //   if (loading || (projects.length <= 0 && loading)) {
  //     return <Loading />;
  //   }
  return (
    <SecondContainer>
      {/* Basic Instructions */}
      {/* <h1 className="text-2xl text font-bold mb-4">Ongoing Applications</h1> */}
      <PageTitle title="Manage Projects" />
      <p className="mb-4 text-text-1/65">
        Below is a list of all ongoing applications pending Approval
      </p>
      {/* Form */}
      <form>
        <AsyncSelectInput
          register={register}
          name="term"
          fetchOptions={getProjectsByTerm}
          setValue={setValue}
          errors={errors.term}
        />
      </form>

      {/* Ongoing Applications Table */}
      {
        <div className="table-container">
          <table className="overflow-auto">
            <thead className=" app-thead">
              <tr>
                <th className="app-thead-th">Num</th>
                <th className="app-thead-th">Title</th>
                <th className="app-thead-th">Date Started</th>
                <th className="app-thead-th">Step Reached</th>
                <th className="app-thead-th">Action</th>
              </tr>
            </thead>
            {projects.length > 0 ? (
              <tbody className="text-text-1/85">
                {projects.map((project, index) => (
                  <tr key={project.id}>
                    {/* Project Num */}
                    <td className="table-data !text-sm">{++index}</td>
                    {/* Project Title */}
                    <td className="table-data !text-base">{project.name}</td>

                    {/* Date Started */}
                    <td className="table-data !text-sm">
                      {new Date(project.updated_at).toDateString()}
                    </td>

                    {/* Step Reached (Assumed it's available in the project object) */}
                    <td className="table-data !text-sm">
                      {project.stage?.step || "Not Started"}
                    </td>

                    {/* Continue Application Button */}
                    <td className="table-data !text-sm text-center">
                      {/* <Link to={"/requests/beneficiary-profile/" + project.id}>
                    <button className="px-4 py-2 bg-green-500/80 text-text-gen rounded hover:bg-green-600">
                      Cont.. Application
                    </button>
                  </Link> */}
                      {
                        <Link
                          to={
                            project.status.toLowerCase() !== "canceled"
                              ? `/projects/manage/${project.id}`
                              : ""
                          }
                        >
                          <button
                            className={
                              project.status.toLowerCase() !== "canceled"
                                ? "px-4 py-2 bg-green-500/80 text-text-gen rounded hover:bg-green-600"
                                : "px-4 py-2 bg-gray-400 text-text-white rounded"
                            }
                            disabled={
                              project.status.toLowerCase() === "canceled"
                            }
                          >
                            Manage Project
                          </button>
                        </Link>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <td colSpan={5}>
                <div className="flex items-center justify-center w-full h-72 rounded-md">
                  <p className="text-text-1/60">
                    No ongoing applications found.
                  </p>
                </div>
              </td>
            )}
          </table>
        </div>
      }
    </SecondContainer>
  );
};

export default ManageProjects;
